import React, { useState, useEffect, useCallback } from 'react';
import { showToast } from '../utils/toast';
import { FiEdit2, FiPlus, FiToggleLeft, FiToggleRight } from 'react-icons/fi';
import api from '../services/api';
import '../styles/Configuracion.css';

export default function MarcasPage() {
  const [rows,       setRows]       = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [error,      setError]      = useState('');
  const [modal,      setModal]      = useState(null);
  const [form,       setForm]       = useState({ nombre: '' });
  const [saving,     setSaving]     = useState(false);
  const [modalError, setModalError] = useState('');

  const load = useCallback(async () => {
    setLoading(true); setError('');
    try {
      const r = await api.get('/api/config/marcas');
      setRows(r.data.data || []);
    } catch (e) { setError(e.response?.data?.error || e.message); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const openNew  = () => { setForm({ nombre: '' }); setModalError(''); setModal({ mode: 'new' }); };
  const openEdit = (r) => { setForm({ nombre: r.nombre }); setModalError(''); setModal({ mode: 'edit', id: r.id }); };

  const handleSave = async () => {
    if (!form.nombre.trim()) { setModalError('El nombre es requerido'); return; }
    setSaving(true); setModalError('');
    try {
      if (modal.mode === 'new') await api.post('/api/config/marcas', form);
      else await api.put(`/api/config/marcas/${modal.id}`, form);
      await load(); setModal(null);
    } catch (e) {
      const msg = e.response?.data?.error || e.message;
      setModalError(msg.includes('Duplicate') ? 'Ya existe una marca con ese nombre.' : msg);
    } finally { setSaving(false); }
  };

  const handleToggle = async (id) => {
    try { await api.patch(`/api/config/marcas/${id}/activo`); await load(); }
    catch (e) { showToast(e.response?.data?.error || 'Error'); }
  };

  return (
    <div className="cfg-page">
      <div className="cfg-toolbar">
        <button className="cfg-btn-nuevo" onClick={openNew}><FiPlus /> Nueva Marca</button>
      </div>

      {loading ? <div className="cfg-loading">Cargando...</div>
       : error  ? <div className="cfg-error">{error}</div>
       : (
        <table className="cfg-table">
          <thead>
            <tr>
              <th className="cfg-th">Marca</th>
              <th className="cfg-th">Estado</th>
              <th className="cfg-th cfg-th-action"></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0
              ? <tr><td colSpan={3} className="cfg-empty">Sin marcas registradas</td></tr>
              : rows.map((r, i) => (
                <tr key={r.id} className={i % 2 === 0 ? 'cfg-row-even' : 'cfg-row-odd'}>
                  <td className="cfg-td" style={{ fontWeight: 600 }}>{r.nombre}</td>
                  <td className="cfg-td">
                    <span style={{
                      display: 'inline-block', padding: '2px 10px', borderRadius: 12,
                      fontSize: 11, fontWeight: 700,
                      color: r.activo ? '#16a34a' : '#dc2626',
                      background: (r.activo ? '#16a34a' : '#dc2626') + '12',
                      border: `1px solid ${(r.activo ? '#16a34a' : '#dc2626')}44`,
                    }}>
                      {r.activo ? 'ACTIVO' : 'INACTIVO'}
                    </span>
                  </td>
                  <td className="cfg-td cfg-td-action">
                    <div className="ia-actions">
                      <button className="ia-btn ia-btn--edit" onClick={() => openEdit(r)} title="Editar"><FiEdit2 size={15} /></button>
                      <button
                        className={`ia-btn ${r.activo ? 'ia-btn--on' : 'ia-btn--off'}`}
                        onClick={() => handleToggle(r.id)}
                        title={r.activo ? 'Desactivar' : 'Activar'}
                      >
                        {r.activo ? <FiToggleLeft size={15} /> : <FiToggleRight size={15} />}
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      )}

      <div className="cfg-footer">
        Todos los Derechos reservados Devel@per F@xy &nbsp;·&nbsp; www.developerfoxy.com
      </div>

      {modal && (
        <div className="cfg-modal-overlay">
          <div className="cfg-modal" onClick={e => e.stopPropagation()}>
            <div className="cfg-modal-header">
              <span>{modal.mode === 'new' ? 'Nueva Marca' : 'Editar Marca'}</span>
              <button className="cfg-modal-close" onClick={() => setModal(null)}>×</button>
            </div>
            <div className="cfg-modal-body">
              <div className="cfg-field-row">
                <label className="cfg-field-label">Nombre *</label>
                <input className="cfg-input" value={form.nombre}
                  onChange={e => setForm(p => ({ ...p, nombre: e.target.value }))}
                  placeholder="Ej: BOSCH, STANLEY, 3M..." autoFocus />
              </div>
            </div>
            {modalError && <div className="cfg-modal-error">{modalError}</div>}
            <div className="cfg-modal-footer">
              <button className="cfg-btn-save" onClick={handleSave} disabled={saving}>
                {saving ? 'Guardando...' : modal.mode === 'new' ? 'Guardar' : 'Modificar'}
              </button>
              <button className="cfg-btn-cancel" onClick={() => setModal(null)}>× Salir</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
